import { RemoveComponent } from '../../app-lite/table/cell-components/actions/remove.component';

import VehicleBodyTypeAddHtml from './templates/vehicle-body-type.add.html';
import VehicleBodyTypesHtml   from './templates/vehicle-body-types.html';
import VehicleGroupsAddHtml   from './templates/vehicle-groups.add.html';

export function AdjustVehicleGroupsCtrl (
  $uibModal,
  $scope,
  $translate,
  groups,
  messages,
  workshopAPI
) {
  $scope.loaded = true;

  $scope.groups = groups;
  $scope.group = $scope.groups[0];
  $scope.body_groups = [];

  $scope.tableSettings = {
    columns: [
      {
        component: {
          bindings: {
            outputs: {
              onRemoveClick: event => $scope.removeItem(event)
            }
          },
          enabled: true,
          factory: RemoveComponent,
        },
        sortable: false,
      },
      {
        field : 'vehicle_body_type',
        header: {
          text: $translate.instant('COMPANY_SPACE.SETTINGS.CODE')
        }
      },
      {
        field : 'description',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
    ],
    empty: {
      text: $translate.instant('VEHICLE_SPACE.NO_TYPES_FOR_DESCRIPTION', {name: $scope.group.description})
    },
    pagination: {
      enabled: false
    },
    sorting: {
      enabled: false
    }
  };

  $scope.newGroup = function () {
    var modalInstance = $uibModal.open({
      templateUrl: VehicleGroupsAddHtml,
      controller: 'newVehicleGroupCtrl'
    });

    modalInstance.result.then(function (obj) {
      $scope.groups = obj.groups;
      $scope.group = obj.group;
      $scope.body_groups = [];
    });
  };

  $scope.newBodyType = function () {
    var modalInstance = $uibModal.open({
      templateUrl: VehicleBodyTypeAddHtml,
      controller: 'newBodyTypeCtrl'
    });

    modalInstance.result.then(function (type) {
      $scope.body_groups.push({
        destroy: '0',
        vehicle_body_group_type: $scope.group.code,
        vehicle_body_type: type.code,
        description: type.description
      });
    });
  };

  $scope.getBodyTypes = function () {
    workshopAPI.get('/vehicle_body_groups', $scope.group.code)
    .then(function (types) {
      angular.forEach(types, function (type) {
        type.destroy = '0';
      });

      $scope.body_groups = types;
    }, function (err) {
      messages.error(err);
    })
  };

  $scope.addBodyType = function () {
    var modalInstance = $uibModal.open({
      templateUrl: VehicleBodyTypesHtml,
      controller: 'bodyTypesByGroupCtrl',
      windowClass: 'lg-modal',
      resolve: {
        group: function () {
          return $scope.group.description;
        },
        body_types: ['$q', 'workshopAPI', function ($q, workshopAPI) {
          var deferred = $q.defer();

          workshopAPI.get('/vehicle_body_types', [false, 0, '*', 'Code', 'asc'])
          .then(function (body_types) {
            var codes = [];
            var unique = [];
            angular.forEach($scope.body_groups, function (btype) {
              if (btype.destroy === '0') {
                codes.push(btype.vehicle_body_type);
              }
            });

            unique = body_types.filter(function (type) {
              return codes.indexOf(type.code) < 0;
            });

            deferred.resolve(unique);
          }, function (err) {
            deferred.reject(err);
          });

          return deferred.promise;

        }]
      }
    });

    modalInstance.result.then(function (types) {
      angular.forEach(types, function (type) {
        type.destroy = '0';
        type.vehicle_body_group_type = $scope.group.code;
        type.vehicle_body_type = type.code;
        type.description = type.description;
      });

      $scope.body_groups = $scope.body_groups.concat(types);
    })
  };

  $scope.removeItem = function (row) {
    workshopAPI.get('/vehicle_body_groups/can_destroy', [$scope.group.code, row.vehicle_body_type])
    .then(function (deletable) {
      if (deletable === 'true') {
        row.destroy = '1';
      }
      else {
        messages.show($translate.instant('JS_SPACE.MESSAGES.COMPANIES_USING_GROUP_CANNOT_DELETE'), 'error');
      }
    }, function (err) {
      messages.error(err);
    })
  };

  $scope.save = function () {
    workshopAPI.post('/vehicle_body_groups', $scope.body_groups, 'vehicle_body_groups')
    .then(function (data) {
      $scope.getBodyTypes();
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.VEHICLE_BODY_GROUPS'), 'success');
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.getBodyTypes();

}